import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@patient-watch/ui/button";
import { SftpReportPreviewPanel } from "@/features/admin/components/SftpReportPreviewPanel";
import type { SftpReportPreviewTarget } from "@/features/admin/hooks/useSftpReportPreview";
import { useNav } from "@/utils/nav";
import { z } from "zod";

const previewSearchSchema = z.object({
    organisationId: z.string().uuid(),
    sftpPath: z.string().min(1),
    diaryId: z.string().uuid().optional(),
    patientId: z.string().uuid().optional(),
    title: z.string().optional(),
    organisationName: z.string().optional(),
});

function SftpReportPreviewPage() {
    const search = Route.useSearch();

    useNav([
        { label: "Developer", route: { to: "/developer" } },
        { label: "SFTP", route: { to: "/developer/sftp/diaries" } },
        { label: "Preview" },
    ]);

    const target: SftpReportPreviewTarget = {
        organisationId: search.organisationId,
        sftpPath: search.sftpPath,
        diaryId: search.diaryId,
        patientId: search.patientId ?? null,
        patientLabel: search.title ?? null,
        organisationName: search.organisationName ?? null,
    };

    return (
        <div className="flex flex-col gap-4 w-full min-w-0">
            <Button asChild type="button" variant="ghost" size="sm" className="self-start gap-2">
                <Link to="/developer/sftp/diaries">
                    <ArrowLeft className="w-4 h-4" />
                    Back to diaries
                </Link>
            </Button>
            <SftpReportPreviewPanel target={target} />
        </div>
    );
}

export const Route = createFileRoute("/_app/developer/sftp/preview")({
    validateSearch: (search) => previewSearchSchema.parse(search),
    component: SftpReportPreviewPage,
});
